"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalQuoteRespondResponseSchema = exports.PortalQuoteRespondRequestSchema = exports.PortalQuoteResponseSchema = exports.PortalQuoteDataSchema = exports.PortalQuoteMetaSchema = exports.PortalQuoteAttachmentSchema = exports.PortalQuoteTermsSchema = exports.PortalQuoteCompanySchema = exports.PortalQuoteTotalsSchema = exports.PortalQuoteLineItemSchema = exports.PortalQuoteTokenParamsSchema = void 0;
const zod_1 = require("zod");
exports.PortalQuoteTokenParamsSchema = zod_1.z.object({
    token: zod_1.z.string().min(1),
});
exports.PortalQuoteLineItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    lineNumber: zod_1.z.number(),
    name: zod_1.z.string(),
    quantity: zod_1.z.number(),
    unit: zod_1.z.string(),
    unitPriceCents: zod_1.z.number(),
    lineTotalCents: zod_1.z.number(),
    notes: zod_1.z.string().optional(),
    isOptional: zod_1.z.boolean(),
});
exports.PortalQuoteTotalsSchema = zod_1.z.object({
    subtotalCents: zod_1.z.number(),
    taxCents: zod_1.z.number(),
    totalExTaxCents: zod_1.z.number(),
    totalIncTaxCents: zod_1.z.number(),
});
exports.PortalQuoteCompanySchema = zod_1.z.object({
    name: zod_1.z.string(),
    logoUrl: zod_1.z.string().nullable(),
    nationalIdentifierType: zod_1.z.string(),
    nationalIdentifier: zod_1.z.string(),
    registeredForTax: zod_1.z.boolean(),
    pricesIncludeTax: zod_1.z.boolean(),
    country: zod_1.z.string(),
});
exports.PortalQuoteTermsSchema = zod_1.z.object({
    standardTermsHtml: zod_1.z.string().nullable(),
    additionalTerms: zod_1.z.string().nullable(),
});
exports.PortalQuoteAttachmentSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: zod_1.z.string(),
    name: zod_1.z.string(),
    extension: zod_1.z.string(),
    url: zod_1.z.string(),
    width: zod_1.z.number().nullable(),
    height: zod_1.z.number().nullable(),
});
exports.PortalQuoteMetaSchema = zod_1.z.object({
    number: zod_1.z.number(),
    name: zod_1.z.string(),
    status: zod_1.z.string(),
    issuedAt: zod_1.z.string(),
    dueDate: zod_1.z.string().nullable(),
    mainAddressDisplay: zod_1.z.string().nullable(),
});
exports.PortalQuoteDataSchema = zod_1.z.object({
    company: exports.PortalQuoteCompanySchema,
    quote: exports.PortalQuoteMetaSchema,
    lineItems: zod_1.z.array(exports.PortalQuoteLineItemSchema),
    totals: exports.PortalQuoteTotalsSchema,
    termsAndConditions: exports.PortalQuoteTermsSchema,
    attachments: zod_1.z.array(exports.PortalQuoteAttachmentSchema),
});
exports.PortalQuoteResponseSchema = zod_1.z.object({
    data: exports.PortalQuoteDataSchema,
});
const portalQuoteAcceptRequestSchema = zod_1.z.object({
    action: zod_1.z.literal('accept'),
    acceptorName: zod_1.z.string().trim().min(1).max(200),
    selectedLineItemIds: zod_1.z.array(zod_1.z.string()).optional(),
    signature: zod_1.z
        .object({
        /** PNG/JPEG/WebP as standard base64, or a `data:image/...;base64,...` data URL */
        imageBase64: zod_1.z.string().min(1).max(3_000_000),
    })
        .optional(),
});
const portalQuoteRejectRequestSchema = zod_1.z.object({
    action: zod_1.z.literal('reject'),
    rejectionReason: zod_1.z.string().trim().max(5000).optional(),
});
const portalQuoteRequestChangesRequestSchema = zod_1.z.object({
    action: zod_1.z.literal('request_changes'),
    message: zod_1.z.string().trim().min(1).max(5000),
});
/** Use `z.union` (not `discriminatedUnion`) so `zodToJsonSchema` + Fastify/Ajv accept all portal actions. */
exports.PortalQuoteRespondRequestSchema = zod_1.z.union([
    portalQuoteAcceptRequestSchema,
    portalQuoteRejectRequestSchema,
    portalQuoteRequestChangesRequestSchema,
]);
exports.PortalQuoteRespondResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        quoteId: zod_1.z.string(),
        outcome: zod_1.z.enum(['accepted', 'rejected', 'changes_requested']),
        jobId: zod_1.z.string().nullable().optional(),
        acceptedAt: zod_1.z.string().optional(),
        rejectedAt: zod_1.z.string().optional(),
        changesRequestedAt: zod_1.z.string().optional(),
    }),
});
